'use client';

import React, {useEffect} from 'react';
import styled from 'styled-components';
import useStore from '../store/useStore';
import posthog from 'posthog-js';

/* --- Styled Components --- */

const TopNavContainer = styled.div`
  width: 100%;
  background-color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem 1rem;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
`;

const LeftSection = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  font-weight: bold;
  font-size: 1.2rem;
  color: #225055;
`;

const UserInfo = styled.span`
  font-size: 1rem;
  font-weight: normal;
`;

const ProjectInfo = styled.span`
  font-size: 1.1rem;
  font-weight: 600;
  color: #1a4b50;
`;

// const CenterSection = styled.div`
//   flex: 1;
//   margin: 0 1rem;
// `;

const RightSection = styled.div`
  display: flex;
  align-items: center;
`;

// const IconButton = styled.button`
//   background: none;
//   border: none;
//   color: #225055;
//   cursor: pointer;
//   font-size: 1.5rem;
//   margin-left: 1rem;
//   padding: 0;

//   &:hover {
//     opacity: 0.8;
//   }
// `;

/* --- Search Bar Integrated into TopNav --- */

// const SearchBarContainer = styled.div`
//   position: relative;
//   width: 100%;
// `;

// const SearchInput = styled.input`
//   width: 100%;
//   padding: 0.5rem 2.5rem 0.5rem 1rem;
//   border: 1px solid #ccc;
//   border-radius: 4px;
//   font-size: 1rem;
// `;

// const SearchIcon = styled.span`
//   position: absolute;
//   right: 0.75rem;
//   top: 50%;
//   transform: translateY(-50%);
//   font-size: 1.2rem;
//   color: #888;
// `;

/* --- TopNav Component --- */

// Title styles for map view
// const ProjectTitle = styled.div`
//   font-size: 1.2rem;
//   font-weight: 500;
//   color: #225055;
//   white-space: nowrap;
//   overflow: hidden;
//   text-overflow: ellipsis;
//   max-width: 100%;
//   padding: 0.5rem 0;
// `;

interface TopNavProps {
  session: any; // Define the type for session if needed
}

const TopNav: React.FC<TopNavProps> = ({ session }) => {
  //Accessing gloabal state using Zustand
  const { currentPageTitle, isMapView, companies, selectedCompany, setSelectedCompany } = useStore();

    useEffect(() => {
        posthog.identify(session.user.email)
    }, []);

  return (
    <TopNavContainer>
      <LeftSection>
        {isMapView && currentPageTitle && (
          <ProjectInfo>{currentPageTitle}</ProjectInfo>
        )}
            {companies && companies.length > 0 && !isMapView && (
              <select
                value={selectedCompany}
                  onChange={e => setSelectedCompany(e.target.value)}
              >
                {companies.map(company => (
                    <option key={company} value={company}>{company}</option>
                ))}
              </select>
            )}
      </LeftSection>

      <RightSection>
      {session?.user?.email && (
          <UserInfo>Logget inn som: {session.user.email}</UserInfo>
        )}
      </RightSection>
    </TopNavContainer>
  );
};

export default TopNav;
